import script from "./ElementToolbar.vue?vue&type=script&lang=ts&setup=true"
export * from "./ElementToolbar.vue?vue&type=script&lang=ts&setup=true"

import "./ElementToolbar.vue?vue&type=style&index=0&id=446388c6&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-446388c6"]])

export default __exports__